import b_ from 'b_';
import cx from 'classnames';
import React from 'react';

import './widget-wrapper.scss';

interface Props {
    children: React.ReactNode;
    fullWidth?: boolean;
    className?: string;
    background?: string;
}

const b = b_.with('widget-wrapper');

export const WidgetWrapper = ({ children, fullWidth, className, background }: Props) => {
    return (
        <div className={cx(b(), className)} style={{ background }}>
            <div className={b('side-block', { left: true, disabled: !fullWidth })} />
            <div style={{ width: 'inherit' }}>{children}</div>
            <div className={b('side-block', { right: true, disabled: !fullWidth })} />
        </div>
    );
};
